<template>
  <div>
    <material-card>
      <v-toolbar slot="header" color="primary">
        <v-toolbar-title>Gift Cards</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          class="ma-2"
          outlined
          color="white"
          v-if="loggedUser.role === '1'"
          @click="giftcardDialog = true"
          :disabled="!canRequestGiftcard"
        >Request Gift Cards</v-btn>
      </v-toolbar>
      <v-data-table
        :headers="giftcardTable.headers"
        :items="giftcardTable.data"
        :options.sync="giftcardTableOptions"
        :server-items-length="giftcardTable.total"
        :loading="giftcardTable.loading"
        dense
        class="elevation-1"
        :footer-props="{
                'items-per-page-options': [5, 10, 15, 20, 30, 50]
              }"
        :items-per-page="5"
      >
      <template v-slot:body.append>
        <tr>
          <td></td>
          <td><strong>Totals:</strong></td>
          <td>
            {{giftcardTable.totals.total}}
          </td>
          <td>
            {{giftcardTable.totals.total_available}}
          </td>
          <td>
            {{giftcardTable.totals.total_scanned}}
          </td>
          <td>
            {{giftcardTable.totals.total_used}}
          </td>
        </tr>
      </template>
        <template slot="headerCell" slot-scope="{ header }">
          <span class="font-weight-light text-warning text--darken-3" v-text="header.text" />
        </template>
        <template v-if="canRequestGiftcard" v-slot:item.client_name="{ item }">
          <a :href="item.link" dark>{{ item.client_name }}</a>
        </template>
      </v-data-table>
    </material-card>

    <v-dialog v-model="giftcardDialog" scrollable max-width="400px">
      <v-card>
        <v-card-title>Request Gift Card</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <v-form ref="giftcardRequest" v-model="giftcardRequest.valid">
            <v-select
              v-model="giftcardRequest.giftCardMerchant"
              :items="campaignMerchants"
              item-value="campaign_id"
              item-text="name"
              label="Merchant"
              return-object
              :rules="[v => !!v || 'Merchant is required']"
            ></v-select>
            <v-text-field
              v-model="giftcardRequest.giftcardAmount"
              type="number"
              min="0"
              label="Number of Gift Cards"
              :rules="[v => (v && v.length > 0) || 'Field is required']"
            ></v-text-field>
            <v-text-field
              v-model="giftcardRequest.giftcardValue"
              type="number"
              min="0"
              label="Value"
              :rules="[v => (v && v.length > 0) || 'Field is required']"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="secondary darken-1" outlined @click="giftcardDialog = false">Cancel</v-btn>
          <v-btn color="primary darken-1" @click="requestGiftcards(); giftcardDialog = false">Request Gift Cards</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import { mapState } from 'vuex'
import apiService from '@/services'
import moment from 'moment'

export default {
  props: {
    campaignMerchants: {
      type: Array,
      default () {
        return []
      }
    },
    canRequestGiftcard: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    console.log('Campaign Merchants', this.campaignMerchants)
    this.getGiftCard(this.$route.params.campaignId)
  },
  watch: {
    giftcardTableOptions: {
      handler () {
        this.getGiftCard(this.$route.params.campaignId)
      },
      deep: true
    }
  },
  data () {
    return {
      giftcardTable: {
        headers: [
          {
            text: 'Client',
            value: 'client_name',
            sortable: true
          },
          {
            text: 'Merchant',
            value: 'merchant_name',
            sortable: true
          },
          {
            text: 'Total',
            value: 'totalGiftcards',
            sortable: true
          },
          {
            text: 'Available',
            value: 'available',
            sortable: true
          },
          {
            text: 'Scanned',
            value: 'scanned',
            sortable: true
          },
          {
            text: 'Used',
            value: 'used',
            sortable: true
          },
          {
            text: 'Value',
            value: 'value',
            sortable: true
          },
          {
            text: 'Creation date',
            value: 'formattedDate',
            sortable: true
          }
        ],
        options: {},
        data: [],
        total: 0,
        loading: true,
        totals: {}
      },
      giftcardTableOptions: {},
      giftcardDialog: false,
      giftcardRequest: {
        valid: true,
        giftcardMerchant: '',
        giftcardAmount: null,
        giftcardValue: null
      }
    }
  },
  computed: {
    ...mapState({
      auth: 'auth',
      alerts: (state) => state.alert.snackbars
    }),
    loggedIn () {
      return this.auth.loggedIn
    },
    loggedUser () {
      return this.auth.user || null
    }
  },
  methods: {

    /**
     * Get qcodes of the Merchant
     */
    getGiftCard (campaignId) {
      this.giftcardTable.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.giftcardTableOptions

      let filter = {}
      filter.sort_by = sortBy[0] || 'campaign_name'
      filter.descending = sortDesc[0]
      filter.page = page
      filter.limit = itemsPerPage
      filter.id = campaignId
      filter.campaign_id = campaignId
      console.log('pre post ', filter)
      apiService
        .getGiftCards(filter)
        .then((response) => {
          console.log('response', response)
          const data = response.data[0]
          this.giftcardTable.totals = response.data[1][0]

          // Format dates to DD-MM-YYYY HH:mm
          data.map(val => {
            val.formattedDate = moment(val.date).format('DD-MM-YYYY HH:mm')
          })

          // this.giftcardTable.data = response.data.results.map((item) => {
          //   item.formattedDate = moment(item.created_at).format('DD/MM/YYYY')
          //   return item
          // })

          this.giftcardTable.data = data
          this.giftcardTable.data.map(i => {
            i.totalGiftcards = i.available + i.used
            return i
          })

          // this.giftcardTable.total = response.data.count
          this.giftcardTable.total = response.data.length || 0

          this.giftcardTable.loading = false
          // this.giftcardTable.totals = response.data.totals
        })
        .catch((error) => {
          this.giftcardTable.loading = false
          console.error(error)
        })
    },

    /**
     * Request GiftCard for merchant
     */
    requestGiftcards () {
      let data = {}
      if (this.$refs.giftcardRequest.validate()) {
        data.campaign_id = this.$route.params.campaignId
        data.merchant_id = this.giftcardRequest.giftCardMerchant.id
        data.client_id = this.giftcardRequest.giftCardMerchant.id
        data.gift_card_size = this.giftcardRequest.giftcardValue
        data.gift_card_num = this.giftcardRequest.giftcardAmount

        console.log('bbbbbb', this.giftcardRequest.giftcardValue)

        apiService
          .requestGiftCards(data)
          .then((response) => {
            this.$store.dispatch('alert/success', 'Giftcard requested successfully')
            this.getGiftCard(this.$route.params.campaignId)
          })
          .catch((error) => {
            this.$store.dispatch('alert/error', error.response.data.message)
          })

        // if (valid) {
        //   const data = {
        //     campaign_id: this.giftcardRequest.giftCardMerchant.campaign_id,
        //     amount: this.giftcardRequest.giftcardAmount
        //   }
        //   apiService
        //     .requestGiftcards(data)
        //     .then((response) => {
        //       this.$store.dispatch('alert/success', 'Giftcard requested successfully')
        //       this.getGiftCard(this.$route.params.campaignId)
        //     })
        //     .catch((error) => {
        //       this.$store.dispatch('alert/error', error.response.data.message)
        //     })
        // }
      } else {
        console.log('Form not valid')
      }
    }
  }
}
</script>
